<div class="login-outer-container">
  <mat-card class="login-card" appearance="outlined">
    <mat-card-header>
      <mat-card-title>
        <h1>
          {{ headerMessage }}
        </h1>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      @if (!isForgotPasswordUrl && !isResetPasswordUrl && !isActiveAccountUrl) {
        <img class="logo" src="/Portals/_default/Skins/Speedgoat2016/images/speedgoat-logo.svg" />
      }

      @if (isForgotPasswordUrl) {
        <app-forgot-password [isActive]="false"></app-forgot-password>
      } @else if (isActiveAccountUrl) {
        <app-forgot-password [isActive]="true"></app-forgot-password>
      } @else if (isResetPasswordUrl) {
        <app-reset-password></app-reset-password>
      } @else {
        <app-login></app-login>
      }
    </mat-card-content>
  </mat-card>

  <div class="info-container"><mat-icon>info</mat-icon> Please clear your browser cache if you experience login issues.</div>
</div>
